import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import { ArrowLeftIcon, ArrowRightIcon } from '@App/common/components/icons/NavigationArrows';
import Icon from '@App/themes/natucare/components/Icon/Icon';
import * as styles from './Reviews.module.scss';
const TrustmateStars = () => /*#__PURE__*/React.createElement("span", {
  className: styles.rootRatingStars,
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "71",
  height: "13",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8766A",
  d: "M5.814 1.05c.154-.312.231-.468.336-.518a.334.334 0 0 1 .287 0c.105.05.181.206.335.518l1.46 2.958a.73.73 0 0 0 .102.174c.03.031.064.057.104.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.595.16.07.073.102.173.089.273-.015.115-.14.236-.389.478L9.833 7.99c-.074.072-.11.108-.134.15a.334.334 0 0 0-.04.123c-.006.048.003.099.02.2l.558 3.25c.058.343.088.514.033.616a.334.334 0 0 1-.233.169c-.114.02-.268-.06-.575-.222l-2.92-1.535a.73.73 0 0 0-.184-.082.33.33 0 0 0-.129 0c-.048.01-.093.034-.184.082l-2.92 1.535c-.308.162-.462.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.026-.272.033-.615l.558-3.25a.73.73 0 0 0 .02-.2.334.334 0 0 0-.04-.123c-.024-.042-.06-.078-.134-.15L.39 5.69c-.248-.243-.373-.364-.388-.48-.013-.099.02-.2.088-.272.08-.084.252-.11.596-.16L3.953 4.3c.101-.015.152-.022.196-.043a.334.334 0 0 0 .104-.075c.033-.036.056-.082.101-.174l1.46-2.958ZM20.401 1.05c.154-.312.23-.468.335-.518a.334.334 0 0 1 .288 0c.104.05.181.206.335.518l1.46 2.958c.046.092.068.138.101.174.03.031.065.057.104.075.044.02.095.028.197.043l3.265.477c.344.05.516.076.596.16.07.073.102.173.089.273-.016.115-.14.236-.389.478L24.42 7.99c-.074.072-.11.108-.135.15a.335.335 0 0 0-.04.123c-.005.048.004.099.02.2l.558 3.25c.06.343.088.514.033.616a.334.334 0 0 1-.232.169c-.114.02-.268-.06-.576-.222l-2.92-1.535c-.09-.048-.136-.072-.184-.082a.33.33 0 0 0-.128 0c-.048.01-.094.034-.185.082l-2.92 1.535c-.307.162-.46.243-.575.222a.334.334 0 0 1-.232-.17c-.055-.1-.026-.272.033-.615l.557-3.25a.733.733 0 0 0 .02-.2.333.333 0 0 0-.04-.123.726.726 0 0 0-.134-.15l-2.362-2.3c-.249-.243-.373-.364-.389-.48-.013-.099.02-.2.09-.272.079-.084.25-.11.595-.16l3.265-.477c.102-.015.153-.022.197-.043a.332.332 0 0 0 .104-.075.729.729 0 0 0 .101-.174l1.46-2.958ZM34.988 1.05c.154-.312.23-.468.335-.518a.334.334 0 0 1 .288 0c.104.05.181.206.335.518l1.46 2.958c.045.092.068.138.101.174.03.031.065.057.104.075.044.02.095.028.197.043l3.265.477c.344.05.516.076.596.16.07.073.102.173.089.273-.016.115-.14.236-.39.478L39.008 7.99c-.074.072-.11.108-.135.15a.334.334 0 0 0-.04.123c-.005.048.004.099.02.2l.558 3.25c.059.343.088.514.033.616a.334.334 0 0 1-.232.169c-.114.02-.268-.06-.576-.222l-2.92-1.535a.732.732 0 0 0-.184-.082.33.33 0 0 0-.128 0 .73.73 0 0 0-.185.082l-2.92 1.535c-.307.162-.46.243-.575.222a.334.334 0 0 1-.232-.17c-.055-.1-.026-.272.033-.615l.557-3.25a.729.729 0 0 0 .02-.2.333.333 0 0 0-.04-.123.726.726 0 0 0-.134-.15l-2.362-2.3c-.249-.243-.373-.364-.389-.48-.013-.099.02-.2.09-.272.079-.084.25-.11.595-.16l3.265-.477a.731.731 0 0 0 .197-.043.335.335 0 0 0 .104-.075c.033-.036.056-.082.101-.174l1.46-2.958ZM49.575 1.05c.154-.312.23-.468.335-.518a.334.334 0 0 1 .287 0c.105.05.182.206.336.518l1.46 2.958a.733.733 0 0 0 .1.174c.03.031.066.057.105.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.596.16.069.073.101.173.088.273-.015.115-.14.236-.389.478L53.593 7.99a.726.726 0 0 0-.134.15.333.333 0 0 0-.04.123c-.005.048.003.099.02.2l.558 3.25c.059.343.088.514.033.616a.334.334 0 0 1-.233.169c-.113.02-.267-.06-.575-.222l-2.92-1.535a.732.732 0 0 0-.184-.082.33.33 0 0 0-.129 0c-.047.01-.093.034-.184.082l-2.92 1.535c-.307.162-.461.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.025-.272.033-.615l.558-3.25c.017-.101.026-.152.02-.2a.335.335 0 0 0-.04-.123c-.024-.042-.06-.078-.134-.15l-2.362-2.3c-.25-.243-.374-.364-.389-.48-.013-.099.02-.2.089-.272.08-.084.251-.11.595-.16l3.266-.477c.102-.015.152-.022.197-.043a.334.334 0 0 0 .103-.075c.034-.036.056-.082.102-.174l1.46-2.958ZM64.162 1.05c.153-.312.23-.468.335-.518a.334.334 0 0 1 .287 0c.105.05.182.206.335.518l1.46 2.958a.729.729 0 0 0 .102.174c.03.031.065.057.104.075.044.02.095.028.196.043l3.266.477c.344.05.516.076.595.16.07.073.102.173.09.273-.016.115-.14.236-.39.478L68.18 7.99c-.073.072-.11.108-.134.15a.333.333 0 0 0-.04.123c-.006.048.003.099.02.2l.558 3.25c.059.343.088.514.033.616a.334.334 0 0 1-.233.169c-.114.02-.267-.06-.575-.222l-2.92-1.535c-.09-.048-.136-.072-.184-.082a.33.33 0 0 0-.129 0 .732.732 0 0 0-.184.082l-2.92 1.535c-.307.162-.461.243-.575.222a.334.334 0 0 1-.233-.17c-.055-.1-.026-.272.033-.615l.558-3.25a.733.733 0 0 0 .02-.2.333.333 0 0 0-.04-.123.726.726 0 0 0-.134-.15l-2.362-2.3c-.25-.243-.374-.364-.389-.48-.013-.099.02-.2.089-.272.08-.084.251-.11.595-.16L62.3 4.3c.101-.015.152-.022.196-.043a.332.332 0 0 0 .104-.075.729.729 0 0 0 .102-.174l1.46-2.958Z"
})));
const Reviews = ({
  trustmate,
  heading,
  link,
  items = [],
  autoplaySingle = false
}) => {
  var _trustmate$scale;
  if (!(items !== null && items !== void 0 && items.length)) return null;
  const {
    0: activeIndex,
    1: setActiveIndex
  } = useState(0);
  const {
    0: unmutedIndex,
    1: setUnmutedIndex
  } = useState(-1);
  const {
    0: allPlaying,
    1: setAllPlaying
  } = useState(false); // IO trigger
  const sectionRef = useRef(null);
  const videoRefs = useRef([]);
  const isMultiAutoplay = !autoplaySingle;
  const ratingValue = trustmate === null || trustmate === void 0 ? void 0 : trustmate.rating;
  const ratingScale = (_trustmate$scale = trustmate === null || trustmate === void 0 ? void 0 : trustmate.scale) !== null && _trustmate$scale !== void 0 ? _trustmate$scale : 5;
  const formattedRatingValue = Number.isFinite(ratingValue) ? ratingValue.toFixed(ratingValue % 1 === 0 ? 0 : 1) : ratingValue;
  const hasRatingValue = formattedRatingValue !== undefined && formattedRatingValue !== null && `${formattedRatingValue}`.trim() !== '';
  const ratingCount = trustmate === null || trustmate === void 0 ? void 0 : trustmate.count;
  const formattedRatingCount = Number.isFinite(ratingCount) ? ratingCount.toLocaleString('pl-PL') : ratingCount;
  const ratingLabel = trustmate === null || trustmate === void 0 ? void 0 : trustmate.label;
  const ratingDescription = formattedRatingCount && ratingLabel ? `${formattedRatingCount} ${ratingLabel}` : formattedRatingCount ? `${formattedRatingCount} opinii` : ratingLabel || '(2167 zweryfikowanych opinii)';
  const hasTrustmateDisplay = hasRatingValue || ratingDescription;
  const emblaOptions = useMemo(() => ({
    align: 'start',
    containScroll: 'trimSnaps',
    skipSnaps: false,
    loop: false
  }), []);
  const [emblaRef, emblaApi] = useEmblaCarousel(emblaOptions);
  const {
    0: canScrollPrev,
    1: setCanScrollPrev
  } = useState(false);
  const {
    0: canScrollNext,
    1: setCanScrollNext
  } = useState(false);
  const {
    0: scrollSnaps,
    1: setScrollSnaps
  } = useState([]);
  const updateNavigationState = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);
  const refreshScrollSnaps = useCallback(() => {
    if (!emblaApi) return;
    setScrollSnaps(emblaApi.scrollSnapList());
  }, [emblaApi]);
  useEffect(() => {
    videoRefs.current = videoRefs.current.slice(0, items.length);
  }, [items.length]);
  useEffect(() => {
    if (!items.length) {
      setActiveIndex(0);
      setUnmutedIndex(-1);
      return;
    }
    setActiveIndex(prev => Math.min(prev, items.length - 1));
  }, [items.length]);

  // 1) IntersectionObserver – gdy sekcja wchodzi do viewportu, uruchamiamy wszystkie
  useEffect(() => {
    const rootEl = sectionRef.current;
    if (!rootEl) return;
    if (!('IntersectionObserver' in window)) {
      setAllPlaying(true);
      return;
    }
    const io = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setAllPlaying(true);
        io.disconnect();
      }
    }, {
      root: null,
      rootMargin: '200px',
      threshold: 0.01
    });
    io.observe(rootEl);
    return () => io.disconnect();
  }, []);

  // 2) Po triggerze IO – preload + load + play wszystkich
  useEffect(() => {
    if (!allPlaying || !isMultiAutoplay) return;
    videoRefs.current.forEach(v => {
      if (!v) return;
      try {
        var _v$load, _v$play;
        v.preload = 'auto'; // zmień z none na auto
        // Jeśli srcset/źródła są statyczne, samo play() też zadziała;
        // load() wymusza rozpoczęcie buforowania natychmiast.
        (_v$load = v.load) === null || _v$load === void 0 ? void 0 : _v$load.call(v);
        v.muted = true; // start globalnie muted
        v.loop = true;
        v.playsInline = true;
        const p = (_v$play = v.play) === null || _v$play === void 0 ? void 0 : _v$play.call(v);
        if (p !== null && p !== void 0 && p.catch) p.catch(() => {});
      } catch (_) {}
    });
  }, [allPlaying, isMultiAutoplay]);

  // 3) Kliknięty slajd = odmutowany, reszta pozostaje z dźwiękiem wyciszonym
  useEffect(() => {
    videoRefs.current.forEach((v, i) => {
      if (!v) return;
      v.muted = unmutedIndex !== i;
      // opcjonalnie: restart klikniętego
      // if (unmutedIndex === i) { try { v.currentTime = 0; } catch(_){} }
    });
  }, [unmutedIndex]);

  // Sprzątanie przy unmount
  useEffect(() => {
    return () => {
      videoRefs.current.forEach(v => {
        try {
          v === null || v === void 0 ? void 0 : v.pause();
        } catch (_) {}
      });
    };
  }, []);
  useEffect(() => {
    if (!emblaApi) return undefined;
    refreshScrollSnaps();
    updateNavigationState();
    return undefined;
  }, [emblaApi, items.length, updateNavigationState, refreshScrollSnaps]);
  useEffect(() => {
    if (!emblaApi) return undefined;
    const onSelect = () => {
      const selected = emblaApi.selectedScrollSnap();
      setActiveIndex(prev => prev === selected ? prev : selected);
    };
    const syncState = () => {
      refreshScrollSnaps();
      updateNavigationState();
      onSelect();
    };
    syncState();
    emblaApi.on('select', syncState);
    emblaApi.on('reInit', syncState);
    emblaApi.on('resize', syncState);
    return () => {
      emblaApi.off('select', syncState);
      emblaApi.off('reInit', syncState);
      emblaApi.off('resize', syncState);
    };
  }, [emblaApi, refreshScrollSnaps, updateNavigationState]);
  const handlePrev = useCallback(() => {
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
  }, [emblaApi]);
  const handleNext = useCallback(() => {
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
  }, [emblaApi]);
  const handleDotClick = useCallback(index => {
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
  }, [emblaApi]);
  const shouldRenderDots = scrollSnaps.length > 1;
  const shouldRenderArrows = scrollSnaps.length > 1;
  const handleVideoClick = index => {
    setActiveIndex(index);
    setUnmutedIndex(prev => prev === index ? -1 : index);
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
  };
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root,
    ref: sectionRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootIntro
  }, hasTrustmateDisplay && /*#__PURE__*/React.createElement("div", {
    className: styles.rootRating
  }, hasRatingValue && /*#__PURE__*/React.createElement(TrustmateStars, null), hasRatingValue && /*#__PURE__*/React.createElement("span", {
    className: styles.rootRatingValue
  }, formattedRatingValue), ratingDescription && /*#__PURE__*/React.createElement("span", {
    className: styles.rootRatingText
  }, ratingDescription), /*#__PURE__*/React.createElement(Icon, {
    name: "v4_trustmate",
    className: styles.rootRatingLogo,
    "aria-hidden": "true"
  })), heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  })), (link === null || link === void 0 ? void 0 : link.label) && /*#__PURE__*/React.createElement("a", {
    className: styles.rootLink,
    href: link.href || '#'
  }, link.label)), /*#__PURE__*/React.createElement("div", {
    className: styles.rootSlider
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCarousel
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCarouselViewport,
    ref: emblaRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCarouselContainer
  }, items.map(({
    id,
    src,
    poster
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: id,
    className: styles.rootSlide
  }, /*#__PURE__*/React.createElement("figure", {
    className: `${styles.rootFigure} ${index === activeIndex ? styles.rootFigureActive : ''}`,
    onClick: () => handleVideoClick(index),
    role: "button",
    tabIndex: 0,
    "aria-pressed": index === unmutedIndex,
    "aria-label": index === unmutedIndex ? 'Wycisz opinię wideo' : 'Odtwórz opinię wideo',
    onKeyDown: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleVideoClick(index);
      }
    }
  }, /*#__PURE__*/React.createElement("video", {
    className: styles.rootVideo,
    preload: "none" // oszczędzamy transfer do momentu IO
    ,

    src: src,
    poster: poster,
    muted: true,
    playsInline: true,
    loop: true,
    ref: node => {
      videoRefs.current[index] = node;
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rootPlayIcon,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "46",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1",
    d: "M22.8 45.453c12.15 0 22-9.85 22-22s-9.85-22-22-22-22 9.85-22 22 9.85 22 22 22Z",
    opacity: ".8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1",
    d: "M16.261 15.514c0-1.25 0-1.874.26-2.222.228-.304.576-.494.955-.521.434-.031.96.307 2.01.982l12.35 7.94c.912.585 1.368.878 1.525 1.251.138.326.138.693 0 1.018-.157.373-.613.666-1.524 1.252l-12.351 7.94c-1.05.675-1.576 1.012-2.01.981a1.309 1.309 0 0 1-.954-.52c-.261-.35-.261-.973-.261-2.222v-15.88Z",
    opacity: ".8"
  }))))))))), (shouldRenderDots || shouldRenderArrows) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootPagination
  }, shouldRenderDots && /*#__PURE__*/React.createElement("div", {
    className: styles.rootDots
  }, scrollSnaps.map((_, index) => /*#__PURE__*/React.createElement("button", {
    type: "button",
    key: `reviews-dot-${index}`,
    className: `${styles.rootDot} ${index === activeIndex ? styles.rootDotActive : ''}`,
    onClick: () => handleDotClick(index),
    "aria-label": `Przejdź do opinii ${index + 1}`,
    "aria-current": index === activeIndex ? 'true' : undefined
  }))), shouldRenderArrows && /*#__PURE__*/React.createElement("div", {
    className: styles.rootArrows
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles.rootArrow} ${styles.rootArrowPrev}`,
    onClick: handlePrev,
    disabled: !canScrollPrev,
    "aria-label": "Poprzednia opinia"
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, null)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles.rootArrow} ${styles.rootArrowNext}`,
    onClick: handleNext,
    disabled: !canScrollNext,
    "aria-label": "Nast\u0119pna opinia"
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null)))))));
};
export default Reviews;